import React, { useState, memo, ChangeEvent } from "react";
import { makeStyles } from "@material-ui/core/styles";
import filterItems from "~libs/filterItems";
import SearcherList from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import getCondicionesFiscales from "./getCondicionesFiscales";

const useStyles = makeStyles(() => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: 10,
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
  },
}));

interface CondicionFiscalSelectorProps {
  value: { label: string | null; value: string | null };
  onChange?: (event: {
    target: { value: { label: string | null; value: string | null } | null };
  }) => void;
}

interface CondicionFiscalItem {
  label: string;
  value: string | null;
}

const condicionesFiscalesList: CondicionFiscalItem[] = getCondicionesFiscales();

const CondicionFiscalSelector: React.FC<CondicionFiscalSelectorProps> = memo(
  ({ value, onChange }) => {
    const [filter, setFilter] = useState<string>("");
    const classes = useStyles();

    const handleItem = (value: CondicionFiscalItem | null) => {
      setFilter("");
      if (onChange) {
        onChange({ target: { value } });
      }
    };

    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
      setFilter(event.target.value);
    };

    return (
      <div className={classes.searcher}>
        <SearcherList
          onClear={() => handleItem(null)}
          filter={filter}
          onChange={handleFilterChange}
          placeholder={"Buscar condición fiscal"}
          borderBottomRounded={undefined}
        />
        <ListView
          onItemSelected={handleItem}
          list={
            filter === ""
              ? condicionesFiscalesList
              : filterItems(condicionesFiscalesList, filter)
          }
        />
      </div>
    );
  }
);

export default CondicionFiscalSelector;
